import React from "react";
import "./terms.css";
import Banner from "./banner";

const PrivacyPolicy = () => {
  return (
    <>
      <Banner
        title="Privacy Policy"
        subtitle="Your privacy is important to us. Please read our privacy practices carefully."
        image="/images/couch.png"
      />

      <div className="terms-wrapper">
        <div className="terms-card">

          <h1 className="terms-title">Privacy Policy</h1>

          <section className="terms-section">
            <h4 className="terms-heading">Overview</h4>

            <p className="terms-text">
              This Privacy Policy describes how Paab India collects,
              uses, and protects your personal information when you
              visit our website, contact us, or use our services.
            </p>

            <p className="terms-text">
              By accessing our website, you agree to the collection
              and use of information in accordance with this policy.
            </p>
          </section>

          <section className="terms-section">
            <h4 className="terms-heading">
              Information We Collect
            </h4>

            <ul className="terms-list">
              <li className="terms-item">
                Name, email address, phone number, and company details.
              </li>

              <li className="terms-item">
                Billing and shipping information.
              </li>

              <li className="terms-item">
                Website usage data and browser information.
              </li>

              <li className="terms-item">
                Information submitted through forms or inquiries.
              </li>
            </ul>
          </section>

          <section className="terms-section">
            <h4 className="terms-heading">
              How We Use Your Information
            </h4>

            <ul className="terms-list">
              <li className="terms-item">
                To provide products and services.
              </li>

              <li className="terms-item">
                To improve customer support and user experience.
              </li>

              <li className="terms-item">
                To process inquiries, orders, and payments.
              </li>

              <li className="terms-item">
                To send important updates or promotional communication.
              </li>
            </ul>
          </section>

          <section className="terms-section">
            <h4 className="terms-heading">
              Data Protection
            </h4>

            <p className="terms-text">
              We implement appropriate security measures to protect
              your personal information against unauthorized access,
              misuse, disclosure, or alteration.
            </p>
          </section>

          <section className="terms-section">
            <h4 className="terms-heading">
              Cookies and Tracking Technologies
            </h4>

            <p className="terms-text">
              Our website may use cookies and similar technologies
              to enhance browsing experience, analyze website traffic,
              and improve our services.
            </p>
          </section>

          <section className="terms-section">
            <h4 className="terms-heading">
              Sharing of Information
            </h4>

            <ul className="terms-list">
              <li className="terms-item">
                We do not sell or rent personal information.
              </li>

              <li className="terms-item">
                Information may be shared with trusted service providers.
              </li>

              <li className="terms-item">
                We may disclose information if required by law.
              </li>
            </ul>
          </section>

          <section className="terms-section">
            <h4 className="terms-heading">
              Third-Party Links
            </h4>

            <p className="terms-text">
              Our website may contain links to third-party websites.
              We are not responsible for the privacy practices or
              content of those websites.
            </p>
          </section>

          <section className="terms-section">
            <h4 className="terms-heading">
              User Rights
            </h4>

            <ul className="terms-list">
              <li className="terms-item">
                Request access to your personal information.
              </li>

              <li className="terms-item">
                Request correction or deletion of your data.
              </li>

              <li className="terms-item">
                Opt out of marketing communications.
              </li>
            </ul>
          </section>

          <section className="terms-section">
            <h4 className="terms-heading">
              Data Retention
            </h4>

            <p className="terms-text">
              We retain personal information only as long as necessary
              for business, legal, and operational purposes.
            </p>
          </section>

          <section className="terms-section">
            <h4 className="terms-heading">
              Children's Privacy
            </h4>

            <p className="terms-text">
              Our services are not directed toward individuals under
              the age of 18, and we do not knowingly collect personal
              information from children.
            </p>
          </section>

          <section className="terms-section">
            <h4 className="terms-heading">
              Changes to Privacy Policy
            </h4>

            <p className="terms-text">
              We may update this Privacy Policy from time to time.
              Any changes will be posted on this page with updated details.
            </p>
          </section>

          <section className="terms-section">
            <h4 className="terms-heading">
              Contact Information
            </h4>

            <p className="terms-text">
              <strong>Email:</strong> contact@paab.in
            </p>

            

            <p className="terms-text">
              <strong>Address:</strong> FACTORY / OFFICEPlot A-163, Sector-80,
Noida, G.B. Nagar,
U.P - 201305, INDIA
            </p>
          </section>

        </div>
      </div>
    </>
  );
};

export default PrivacyPolicy;